import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { MaskedLine, FadeUp, Kicker } from "@/components/Reveal";
import { ProductCard } from "@/components/ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("Tutti");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Negozio — Luca Mannu Giardini";
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const categories = useMemo(() => ["Tutti", ...new Set(products.map((p) => p.category))], [products]);
  const visible = category === "Tutti" ? products : products.filter((p) => p.category === category);

  return (
    <main className="pt-32" data-testid="shop-page">
      <header className="mx-auto max-w-7xl px-6 lg:px-10">
        <Kicker>Il negozio</Kicker>
        <h1 className="mt-4 font-serif text-5xl tracking-tight text-forest md:text-6xl">
          <MaskedLine delay={0.1}>Il vivaio</MaskedLine>
          <MaskedLine delay={0.22} className="italic text-moss">a portata di mano.</MaskedLine>
        </h1>
        <FadeUp delay={0.35}>
          <p className="mt-6 max-w-xl leading-relaxed text-sage">
            Piante sane dal mio vivaio e gli attrezzi che uso davvero. Consegna in tutta la Sardegna, spedizione concordata dopo l'ordine.
          </p>
        </FadeUp>
        <FadeUp delay={0.45} className="mt-10 flex flex-wrap gap-3">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setCategory(c)}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className={`rounded-full border px-5 py-2 font-accent text-xs uppercase tracking-[0.18em] transition-colors duration-300 ${
                category === c ? "border-forest bg-forest text-bone" : "border-line text-sage hover:border-forest hover:text-forest"
              }`}
            >
              {c}
            </button>
          ))}
        </FadeUp>
      </header>

      <section className="mx-auto max-w-7xl px-6 pb-32 pt-16 lg:px-10">
        {loading && <p className="text-sage" data-testid="shop-loading">Caricamento prodotti…</p>}
        {!loading && visible.length === 0 && <p className="text-sage" data-testid="shop-empty">Nessun prodotto in questa categoria.</p>}
        <div className="grid gap-x-10 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </section>
    </main>
  );
}
